module.exports = __webpack_public_path__ + "img/loading.d6d1fcee.svg";